import type { SearchTerritoriesParams } from './territory.api';

export const territoryKeys = {
  all: ['territories'] as const,
  detail: (id: string): readonly unknown[] => [...territoryKeys.all, 'detail', id] as const,
  search: (params: SearchTerritoriesParams): readonly unknown[] => [...territoryKeys.all, 'search', params] as const,
};
